import { Emitter, Event } from "./events.js";

export interface IUserProfileChangedEvent {
    user: IUserProfile;
}

export interface IUserProfile {
    id: string;
    name: string | undefined | null;
    email?: string | undefined | null;
    avatarUrl?: string | undefined | null;

    readonly onDidChange: Event<IUserProfileChangedEvent>;
}

export class UserProfile implements IUserProfile {
    id: string;
    name: string | undefined | null;
    email?: string | undefined | null;
    avatarUrl?: string | undefined | null;

    private _onDidChange = new Emitter<IUserProfileChangedEvent>();
    public readonly onDidChange = this._onDidChange.event;

    constructor(id: string, name?: string | null, email?: string | null, avatarUrl?: string | null) {
        this.id = id;
        this.name = name;
        this.email = email;
        this.avatarUrl = avatarUrl;
    }
}


export interface ITeamChangedEvent {
    team: ITeam;
}

export interface ITeam {
    readonly id: string;
    name: string;
    
    readonly onDidChange: Event<ITeamChangedEvent>;
}
export class Team implements ITeam {
    readonly id: string;
    name: string;

    private _onDidChange = new Emitter<ITeamChangedEvent>();
    public readonly onDidChange = this._onDidChange.event;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
}